import AppContext from "PFApp/app_context";
import PageTabs from "PFComponents/page/page_tabs";
import PropTypes from "prop-types";
import React, { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";

import css from "./tabs.module.scss";

const Tabs = ({ qaId }) => {
  const {
    store: {
      pages: {
        workflowPage: { tab, isEngagementEnabled, isRoleEnabled, isPlannerEnabled, changeTab }
      }
    }
  } = useContext(AppContext);
  const { t } = useTranslation("workflow");

  const tabs = useMemo(() => {
    const tabs = [];
    isEngagementEnabled && tabs.push({ id: "engagements", displayElement: t("parts.engagements.tabTitle") });
    isRoleEnabled && tabs.push({ id: "roles", displayElement: t("parts.roles.tabTitle") });
    isPlannerEnabled && tabs.push({ id: "planner", displayElement: t("parts.planner.tabTitle") });
    return tabs;
  }, [t]);

  return (
    <PageTabs
      rootClassName={css.tabs}
      items={tabs}
      active={tab}
      handleClick={(value) => changeTab(value.id)}
      qaId={qaId}
    />
  );
};

Tabs.propTypes = {
  qaId: PropTypes.string
};

export default Tabs;
